import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { authApi } from '../auth';

export const taskPlanTemplateApiV2 = createApi({
    reducerPath: 'taskPlanTemplateApiV2',
    baseQuery: axiosBaseQuery({
        baseUrl: "/tasks/template",
    }),
    tagTypes: ["TaskPlanTemplate"],
    endpoints: (builder) => ({
        getTaskPlanTemplates: builder.query({
            query: ({ page = 1, limit = 10, search = "", sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: `/tasklist_v2`,
                data: { page, limit, sort, search }
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TaskPlanTemplate"]
        }),

        getTaskPlanTemplatesLibrary: builder.query({
            query: ({ search = "" }) => ({
                method: "PATCH",
                url: `/tasklist_library`,
                data: { search }
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TaskPlanTemplate"]
        }),

        getSingleTaskPlanTemplates: builder.query({
            query: ({ id }) => ({
                method: "GET",
                url: `/view_v2/${id}`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TaskPlanTemplate"]
        }),

        CreateTaskPlanTemplate: builder.mutation({
            query: (values) => ({
                method: "POST",
                url: `/create_v2`,
                data: values
            }),
            transformResponse: (response) => {
                return response;
            },
            invalidatesTags: ["TaskPlanTemplate"]
        }),

        UpdateTaskPlanTemplates: builder.mutation({
            query: ({ values, id }) => ({
                method: "PATCH",
                url: `/update_v2/${id}`,
                data: values
            }),
            transformResponse: (response) => {
                return response;
            },
            invalidatesTags: ["TaskPlanTemplate"]
        }),

        deleteTaskPlanTemplate: builder.mutation({
            query: ({ id }) => ({
                method: "DELETE",
                url: `/remove_v2/${id}`,
            }),
            transformResponse: (response) => {
                return response;
            },
            invalidatesTags: ["TaskPlanTemplate"]
        }),
    }),
})

export const {
    useCreateTaskPlanTemplateMutation,
    useGetTaskPlanTemplatesQuery,
    useGetSingleTaskPlanTemplatesQuery,
    useUpdateTaskPlanTemplatesMutation,
    useGetTaskPlanTemplatesLibraryQuery,
    useDeleteTaskPlanTemplateMutation
} = taskPlanTemplateApiV2;